module.exports = __webpack_public_path__ + "static/media/subscribeGuide3_Jap.7514774b.png";